// extracted by mini-css-extract-plugin
export default {"title":"TitleUser_title__zWGX6","title-wp":"TitleUser_title-wp__9lZbS"};